module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAQ5JREFUaEPtmeERgjAMhfMmUyfREdxA3QQnUTfQDXCSeP1XqtwBD67Ee/0JTUre10JCYMEHgj+/KYDaBOMTcPdboeILwDG/5u4HM9vXVvvX+nB3L248AGyLAM5mdlIACyggAguIOspl/LfQqHBXOFkEakMRAREgFdAWIgWkzUWAlpB0kJK5Mk1+A2iKdDql1xtyrTnMrwDa3FG0bHQH4K4A5tgLE338J4FU7+aj7TnEnTp5ooKsWfN1iFmPte31IRMBUgFtIVJA2lwEaAlJByJACkibxyewkv7ABUCZkw2is5aCRgHkuGq0mCgCnRrTzJ49Tb7U6FtqpDy/8yNh6ELx30JDI13rPBGoTSY8gQ8hK5rdD5yP6AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-index-62.png
// module id = mYhn
// module chunks = 75